'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/components/private-route.js';
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _propTypes = require('prop-types');
var _reactRouterDom = require('react-router-dom');
var _selectors = require('../selectors');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}

/* eslint react/jsx-no-bind: 0 */

PrivateRoute.propTypes = {
  component: _propTypes.func,
  render: _propTypes.func,
  loggedIn: _propTypes.bool.isRequired
};
PrivateRoute.defaultProps = {
  component: undefined,
  render: undefined
};
function PrivateRoute(_ref) {
  var _this = this;
  var Component = _ref.component,
    render = _ref.render,
    loggedIn = _ref.loggedIn,
    rest = _objectWithoutProperties(_ref, ['component', 'render', 'loggedIn']);
  var createComponent = function createComponent(props) {
    if (typeof Component !== 'undefined') {
      return _react2.default.createElement(Component, Object.assign({}, props, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 23
        },
        __self: _this
      }));
    }
    return render(props);
  };
  return _react2.default.createElement(_reactRouterDom.Route, Object.assign({}, rest, {
    render: function render(props) {
      if (loggedIn) {
        return createComponent(props);
      }
      return _react2.default.createElement(_reactRouterDom.Redirect, {
        to: '/login',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 34
        },
        __self: _this
      });
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28
    },
    __self: this
  }));
}
exports.default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(function (state) {
  return {
    loggedIn: (0, _selectors.isLoggedIn)(state)
  };
})(PrivateRoute));